/**
 * Entidad Customer
 * Cliente de la tienda
*/
import { Phone } from "../common/Phone";

export interface Customer {
  id: string;
  accountId: string;
  firstName?: string;
  lastName?: string;
  email: string;
    phone?: Phone;
    newsletter: boolean;
    status: CustomerStatus;
  createdAt: Date;
  updatedAt: Date;
  deletedAt?: Date | null;
}

export enum CustomerStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  BLACKLISTED = 'BLACKLISTED', // e.g., for fraudulent activity
  PENDING = 'PENDING', // e.g., email verification needed
}